export default {
  GET_WORK_INSTRUCTION_PACKAGES: (state) => {
    return [...state.workInstructionPackages].sort((a, b) => {
      const orderDiff = (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity);
      if (orderDiff !== 0) return orderDiff;
      return (a.createdAt ?? '').localeCompare(b.createdAt ?? '');
    });
  },
  CURRENT_WORK_INSTRUCTION_PACKAGE: (state) => {
    return state.currentWorkInstructionPackage;
  },
  GET_WORK_INSTRUCTION: (state) => {
    return state.currentWorkInstruction;
  },
  JOB_HAS_WORK_INSTRUCTIONS: (state) => {
    return state.jobWorkInstructionStatus.hasInstructions;
  },
  JOB_WORK_INSTRUCTION_COUNT: (state) => {
    return state.jobWorkInstructionStatus.instructionCount;
  },
  JOB_WORK_INSTRUCTION_STATUS_LOADING: (state) => {
    return state.jobWorkInstructionStatus.loading;
  },
  JOB_WORK_INSTRUCTION_STATUS_LOADED: (state) => {
    return state.jobWorkInstructionStatus.statusLoaded;
  },
};
